import React, { useEffect, useRef } from "react";
import { SFStack } from "../grid";
import SFIconButton from "../button/iconButton";
import { SFCopilotIcon, SFCloseIcon } from "../icons";
import SFCard, { SFCardHeader } from "../card";
import getStyled from "../../hooks/getStyled";
import SFTypography from "../typography";
import { Fade } from "@mui/material";

const { styled } = getStyled();

const VerticalCard = styled(SFCard)({
  width: "350px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  maxHeight: "100%",
});

const CardHeader = styled(SFCardHeader)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey200.main}`,
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

const VerticalCardContent = styled("div")(({ theme }) => ({
  overflowY: "auto",
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(10),
  height: "80vh",
  width: "100%",
}));

const SFCopilotCardContainer = ({ open, onClose, children, title }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (open && scrollRef.current) {
      // Scroll to the bottom
      const scrollElement = scrollRef.current;
      scrollElement.scrollTop = scrollElement.scrollHeight;
    }
  }, [open, children, scrollRef.current]);

  if (!open) return null;
  return (
    <Fade in={open}>
      <div>
        <VerticalCard>
          <CardHeader
            action={
              <SFIconButton onClick={onClose}>
                <SFCloseIcon />
              </SFIconButton>
            }
            avatar={<SFCopilotIcon color="blue500" size="small" />}
            title={
              <SFTypography variant="cardSectionHeading" color="blue500">
                {title}
              </SFTypography>
            }
          />
          <VerticalCardContent ref={scrollRef}>
            <SFStack spacing={2}>{children}</SFStack>
          </VerticalCardContent>
        </VerticalCard>
      </div>
    </Fade>
  );
};

export default SFCopilotCardContainer;
